import { render, staticRenderFns } from "./ChangelogDrawer.vue?vue&type=template&id=7604d691&scoped=true"
import script from "./ChangelogDrawer.vue?vue&type=script&lang=js"
export * from "./ChangelogDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChangelogDrawer.vue?vue&type=style&index=0&id=7604d691&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7604d691",
  null
  
)

export default component.exports